import ResourceComponent from '../ResourceComponent.vue'

export default [
    {
        path: '/resources',
        name: 'Resources',
        meta: { layout: 'default' },
        component: ResourceComponent,
    },
]